import Box from "@mui/material/Box";
import "./index.scss";

const SaveConfirm = ({ onSave, onClose }) => {
    return (
        <Box className="save-layer-wrapper">
            <Box className="top-box">
                Save your project as a draft before closing?
            </Box>
            <Box className="actions">
                <button className="close" onClick={onClose}>Close</button>
                <button className="save" onClick={onSave}>Save</button>
            </Box>
            
        </Box>
    )
}

export default SaveConfirm